export enum DiscountType {
  Percentage = 0,
  Fixed = 1,
}
